import React from "react";
import { useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function VkplayDmr({ developerId, header }) {
    const params = useParams();
    const { apiData } = useAppApi(
        url_reverse("api:developer:statistics:vkplay_dmr", { developer_id: developerId, kind: params.kind })
    );

    if (!apiData) return;

    const moment = require("moment");
    const chosenDate = apiData.forms_data
        ? moment(new Date(apiData.forms_data.filter.data.year, apiData.forms_data.filter.data.month, 0))
        : null;
    const goodDate = chosenDate && moment().startOf("month") >= chosenDate;
    const buttons = (
        <>
            <ExportButton
                disabled={!goodDate}
                prms={{
                    "filter-month": apiData.forms_data?.filter.data.month,
                    "filter-year": apiData.forms_data?.filter.data.year,
                    "filter-order_type": apiData.forms_data?.filter.data.order_type,
                }}
            />
        </>
    );

    return (
        <ListingCard header={header} filterComponent={false}>
            <RenderForm prefix="filter" buttons={buttons} />
        </ListingCard>
    );
}
